__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/c6a73599bd2fb3a6a2bb179149640330ee14a8059a97902699da5ea2/";